<h3
  *ngIf="showHeading"
  [id]="field?.id"
  class="agpr-conditionalTextHeadingField"
>
  {{ field?.heading | localize }}
</h3>